import React, { useState, useEffect, useMemo, useCallback } from "react";
// npm install react-beautiful-dnd
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { v4 } from "uuid";

/*
const itemsFromBackend = [
  { id: v4(), content: "First task" },
  { id: v4(), content: "Second task" },
  { id: v4(), content: "Third task" },
  { id: v4(), content: "Fourth task" },
  { id: v4(), content: "Fifth task" },
];

const columnsFromBackend = {
  [v4()]: {
    name: "Requested",
    items: itemsFromBackend,
  },
  [v4()]: {
    name: "To do",
    items: [],
  },
  [v4()]: {
    name: "In Progress",
    items: [],
  },
  [v4()]: {
    name: "Done",
    items: [],
  },
};
console.log("columnsFromBackend", columnsFromBackend);
*/

const onDragEnd = (result, columns, setColumns) => {
  //console.log("result (onDragEnd)", result);
  //console.log("columns (onDragEnd)", columns);
  //console.log("setColumns (onDragEnd)", setColumns);

  if (!result.destination) return;
  const { source, destination } = result;

  if (source.droppableId !== destination.droppableId) {
    const sourceColumn = columns[source.droppableId];
    const destColumn = columns[destination.droppableId];
    const sourceItems = [...sourceColumn.items];
    const destItems = [...destColumn.items];
    const [removed] = sourceItems.splice(source.index, 1);
    destItems.splice(destination.index, 0, removed);
    setColumns({
      ...columns,
      [source.droppableId]: {
        ...sourceColumn,
        items: sourceItems,
      },
      [destination.droppableId]: {
        ...destColumn,
        items: destItems,
      },
    });
  } else {
    const column = columns[source.droppableId];
    const copiedItems = [...column.items];
    const [removed] = copiedItems.splice(source.index, 1);
    copiedItems.splice(destination.index, 0, removed);
    setColumns({
      ...columns,
      [source.droppableId]: {
        ...column,
        items: copiedItems,
      },
    });
  }
};

function DragDrop() {
  const [itemsFromBackend, setItemsFromBackend] = useState([]);
  const [update, setUpdate] = useState([]);

  const ophalenData = useCallback(async () => {
    try {
      const responseToken = await fetch(
        "https://www.marchouben.nl/php/generate-jwt.php"
      );
      const dataToken = await responseToken.json();

      const response = await fetch(
        "https://www.marchouben.nl/php/taken-get.php",
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${dataToken.value}`,
          },
        }
      );

      if (!response.ok) {
        console.log(response.status);
        throw new Error("Something went wrong: " + response.status);
      }

      const data = await response.json();
      console.log(data);
      setItemsFromBackend(data);
      //setInitialMovies(data);
    } catch (error) {
      console.log(error.message);
    }
  }, []);

  useEffect(() => {
    ophalenData();
  }, [ophalenData]);

  const gepland = useMemo(
    () => itemsFromBackend.filter((item) => item.status === "Gepland"),
    [itemsFromBackend]
  );
  //console.log("gepland", gepland);
  const start = useMemo(
    () => itemsFromBackend.filter((item) => item.status === "Start"),
    [itemsFromBackend]
  );
  //console.log("start", start);
  const onderhanden = useMemo(
    () => itemsFromBackend.filter((item) => item.status === "Onderhanden"),
    [itemsFromBackend]
  );
  //console.log("onderhanden", onderhanden);
  const voltooid = useMemo(
    () => itemsFromBackend.filter((item) => item.status === "Voltooid"),
    [itemsFromBackend]
  );
  //console.log("voltooid", voltooid);

  const columnsFromBackend = useMemo(
    () => ({
      [v4()]: {
        status: "Gepland",
        items: gepland,
      },
      [v4()]: {
        status: "Start",
        items: start,
      },
      [v4()]: {
        status: "Onderhanden",
        items: onderhanden,
      },
      [v4()]: {
        status: "Voltooid",
        items: voltooid,
      },
    }),
    [gepland, start, onderhanden, voltooid]
  );
  //console.log("columnsFromBackend", columnsFromBackend);

  const [columns, setColumns] = useState(columnsFromBackend);

  useEffect(() => {
    setColumns(columnsFromBackend);
  }, [columnsFromBackend]);

  //console.log("columns", columns);

  useEffect(() => {
    setUpdate(
      Object.entries(columns).map(([columnId, column]) => {
        //console.log("columnId", columnId);
        //console.log("status", column.status);
        //console.log('items', column.items)
        let myArr = [];
        column.items.map((item) =>
          column.status !== item.status ? myArr.push(item.id) : ""
        );
        return myArr;
      })
    );
  }, [columns]);

  function saveHandler() {
    //console.log("update", update);
    const arrGepland = update.slice(0, 1).flat();
    //console.log("arrGepland", arrGepland);
    const arrStart = update.slice(1, 2).flat();
    //console.log("arrStart", arrStart);
    const arrOnderhanden = update.slice(2, 3).flat();
    //console.log("arrOnderhanden", arrOnderhanden);
    const arrVoltooid = update.slice(-1).flat();
    //console.log("arrVoltooid", arrVoltooid);

    //console.table(itemsFromBackend);

    const existingsRecordsToBecomeGepland = arrGepland.map(
      (item) =>
        itemsFromBackend[
          itemsFromBackend.findIndex(
            (itemBackend) => itemBackend.id === item.toString()
          )
        ]
    );
    //console.log(
    //  "existingsRecordsToBecomeGepland",
    //  existingsRecordsToBecomeGepland
    //);

    const existingsRecordsToBecomeStart = arrStart.map(
      (item) =>
        itemsFromBackend[
          itemsFromBackend.findIndex(
            (itemBackend) => itemBackend.id === item.toString()
          )
        ]
    );
    //console.log("existingsRecordsToBecomeStart", existingsRecordsToBecomeStart);

    const existingsRecordsToBecomeOnderhanden = arrOnderhanden.map(
      (item) =>
        itemsFromBackend[
          itemsFromBackend.findIndex(
            (itemBackend) => itemBackend.id === item.toString()
          )
        ]
    );
    //console.log(
    //  "existingsRecordsToBecomeOnderhanden",
    //  existingsRecordsToBecomeOnderhanden
    //);

    const existingsRecordsToBecomeVoltooid = arrVoltooid.map(
      (item) =>
        itemsFromBackend[
          itemsFromBackend.findIndex(
            (itemBackend) => itemBackend.id === item.toString()
          )
        ]
    );
    //console.log(
    //  "existingsRecordsToBecomeVoltooid",
    //  existingsRecordsToBecomeVoltooid
    //);

    let updatedItemGepland;
    for (let i = 0; i < existingsRecordsToBecomeGepland.length; i++) {
      updatedItemGepland = {
        id: existingsRecordsToBecomeGepland[i].id.toString(),
        taak: existingsRecordsToBecomeGepland[i].taak,
        status: "Gepland",
        begindatum: existingsRecordsToBecomeGepland[i].begindatum,
        einddatum: existingsRecordsToBecomeGepland[i].einddatum,
      };

      //console.log("updatedItemGepland", updatedItemGepland);

      const response = fetch("https://www.marchouben.nl/php/taken-put.php", {
        method: "POST",
        //withCredentials: true,
        body: JSON.stringify(updatedItemGepland),
        headers: {
          "Content-Type": "text/plain",
          //Authorization: `Bearer ${dataToken.value}`
        },
      });

      console.log("response (Gepland)", response);
      //const dataGepland = response.json();
      //console.log(dataGepland);
    }

    let updatedItemStart;
    for (let i = 0; i < existingsRecordsToBecomeStart.length; i++) {
      updatedItemStart = {
        id: existingsRecordsToBecomeStart[i].id.toString(),
        taak: existingsRecordsToBecomeStart[i].taak,
        status: "Start",
        begindatum: existingsRecordsToBecomeStart[i].begindatum,
        einddatum: existingsRecordsToBecomeStart[i].einddatum,
      };

      //console.log("updatedItemStart", updatedItemStart);

      const response = fetch("https://www.marchouben.nl/php/taken-put.php", {
        method: "POST",
        //withCredentials: true,
        body: JSON.stringify(updatedItemStart),
        headers: {
          "Content-Type": "text/plain",
          //Authorization: `Bearer ${dataToken.value}`
        },
      });

      console.log("response (Start)", response);
      //const dataStart = response.json();
      //console.log(dataStart);
    }

    let updatedItemOnderhanden;
    for (let i = 0; i < existingsRecordsToBecomeOnderhanden.length; i++) {
      updatedItemOnderhanden = {
        id: existingsRecordsToBecomeOnderhanden[i].id.toString(),
        taak: existingsRecordsToBecomeOnderhanden[i].taak,
        status: "Onderhanden",
        begindatum: existingsRecordsToBecomeOnderhanden[i].begindatum,
        einddatum: existingsRecordsToBecomeOnderhanden[i].einddatum,
      };

      //console.log("updatedItemOnderhanden", updatedItemOnderhanden);

      const response = fetch("https://www.marchouben.nl/php/taken-put.php", {
        method: "POST",
        //withCredentials: true,
        body: JSON.stringify(updatedItemOnderhanden),
        headers: {
          "Content-Type": "text/plain",
          //Authorization: `Bearer ${dataToken.value}`
        },
      });

      console.log("response (Onderhanden)", response);
      //const dataOnderhanden = response.json();
      //console.log(dataOnderhanden);
    }

    let updatedItemVoltooid;
    for (let i = 0; i < existingsRecordsToBecomeVoltooid.length; i++) {
      updatedItemVoltooid = {
        id: existingsRecordsToBecomeVoltooid[i].id.toString(),
        taak: existingsRecordsToBecomeVoltooid[i].taak,
        status: "Voltooid",
        begindatum: existingsRecordsToBecomeVoltooid[i].begindatum,
        einddatum: existingsRecordsToBecomeVoltooid[i].einddatum,
      };

      //console.log("updatedItemVoltooid", updatedItemVoltooid);

      const response = fetch("https://www.marchouben.nl/php/taken-put.php", {
        method: "POST",
        //withCredentials: true,
        body: JSON.stringify(updatedItemVoltooid),
        headers: {
          "Content-Type": "text/plain",
          //Authorization: `Bearer ${dataToken.value}`
        },
      });

      console.log("response (Voltooid)", response);
      //const dataVoltooid = response.json();
      //console.log(dataVoltooid);
    }
  }

  return (
    <>
      <div
        style={{ display: "flex", justifyContent: "center", height: "100%" }}
      >
        <DragDropContext
          onDragEnd={(result) => onDragEnd(result, columns, setColumns)}
        >
          {Object.entries(columns).map(([columnId, column], index) => {
            return (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
                key={columnId}
              >
                <h2>{column.status}</h2>
                <div style={{ margin: 8 }}>
                  <Droppable droppableId={columnId} key={columnId}>
                    {(provided, snapshot) => {
                      return (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                          style={{
                            background: snapshot.isDraggingOver
                              ? "lightblue"
                              : "lightgrey",
                            padding: 4,
                            width: 250,
                            minHeight: 500,
                          }}
                        >
                          {column.items.map((item, index) => {
                            return (
                              <Draggable
                                key={item.id}
                                draggableId={item.id}
                                index={index}
                              >
                                {(provided, snapshot) => {
                                  return (
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      style={{
                                        userSelect: "none",
                                        padding: 16,
                                        margin: "0 0 8px 0",
                                        minHeight: "50px",
                                        backgroundColor: snapshot.isDragging
                                          ? "#263B4A"
                                          : "#456C86",
                                        color: "white",
                                        ...provided.draggableProps.style,
                                      }}
                                    >
                                      {item.id} {item.taak}
                                    </div>
                                  );
                                }}
                              </Draggable>
                            );
                          })}
                          {provided.placeholder}
                        </div>
                      );
                    }}
                  </Droppable>
                </div>
              </div>
            );
          })}
        </DragDropContext>
      </div>
      <button type="button" onClick={saveHandler}>
        Opslaan
      </button>
    </>
  );
}

export default DragDrop;
